<template>
    <div class="header">

    </div>
</template>

<script>
// 引入api模块
export default {
//        组件名称
  name: 'Header',
  //        初始化数据
  data () {
    return { }
  },
  //        方法集
  methods: {

  },
  //        进入加载
  created () {
  }
}
</script>
<style scoped>
  .header{
    background-color: #e0e3e8;
    height: 80px
  }

</style>



// WEBPACK FOOTER //
// src/layout/BackendHeader.vue